import { render, staticRenderFns } from "./ClinicasLab.vue?vue&type=template&id=d4a9db2c&scoped=true"
import script from "./ClinicasLab.vue?vue&type=script&lang=js"
export * from "./ClinicasLab.vue?vue&type=script&lang=js"
import style0 from "./ClinicasLab.vue?vue&type=style&index=0&id=d4a9db2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a9db2c",
  null
  
)

export default component.exports